<template>
  <div class="newPatient-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span>{{ $t('t1215_Security') }}</span>
          </div>
          <div class="main-header-right"  @click="back" :class="{'de22':isDe||isFr,'cz22':isCz}">
            <img src="../../assets/back.png">
            <p>{{$t('home')}}</p>
          </div>
        </div>
        <div class="content  content1" style="margin-top: 40px;"  :class="{'es1':isEs,'de1':isDe,'du1':isDu,'fr1':isFr,'cz1':isCz}">
          <span class="MFA-option" :class="{'it3':isIt,'po3':isPo,'du2':isDu,'de12':isDe,'es13':isEs||isSw,'fr13':isFr||isCz}">{{$t('t1215_MFA')}}</span>
          <div class="MFA-left" :class="{'MFA-choose':MFA}" @click="changeMFA(true)">
            <p>{{$t('On')}}</p>
          </div>
          <div class="MFA-right" :class="{'MFA-choose':!MFA}"  @click="changeMFA(false)">
            <p>{{$t('Off')}}</p>
          </div>
          <div style="clear: both"></div>
        </div>

        <hr class="small-hr">
        <div class="content  content1" style="margin-top: 50px;padding-bottom: 30px;"  :class="{'es1':isEs,'de1':isDe,'du1':isDu,'fr1':isFr,'cz1':isCz}">
          <span>{{$t('oldPa')}}</span><input type="password" v-model="password">
        </div>
        <div class="content content2" :class="{'zh1':!isEn,'es2':isEs,'de1':isDe,'it1':isIt,'po1':isPo,'du2':isDu,'sw2':isSw,'cz2':isCz}">
          <span>{{$t('newPa')}}</span>
          <el-tooltip :disabled= disF  placement="bottom" effect="light">
            <div class="tooltip"  slot="content">
              <p class="longP" :class="{'correct1':ps1}">{{$t('errp1')}}<br>{{$t('errp2')}}</p>
              <p :class="{'correct':ps2}">{{$t('errp3')}}</p>
              <p :class="{'correct':ps3}">{{$t('errp4')}}</p>
              <p :class="{'correct':ps4}">{{$t('errp5')}}</p>
              <p :class="{'correct':ps5}">{{$t('errp6')}}</p>
              <p :class="{'correct':ps6}">{{$t('errp7')}}</p>
            </div>
            <input  type="text" :class="{'vuerify-invalid':isT}" v-model="new_password" @blur="checkPassword">
          </el-tooltip>
        </div>
        <div class="content" :class="{'zh2':!isEn,'it2':isIt,'po2':isPo,'fr2':isFr,'sw3':isSw}">
          <span>{{$t('RePa')}}</span><input type="text" v-model="new_password2">
        </div>
        <div class="forgot">
          <p @click="forgot">{{$t('forgetY')}}</p>
        </div>
        <hr class="small-hr">
        <div class="operate">
          <button class="cancel" @click="back">{{$t('Cancel')}}</button>
          <button class="create" @click="apply">{{$t('save')}}</button>
        </div>
      </el-card>
      <div class="Hcp-footer">
      <span>
<!--           <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
        <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

          {{$t('copyright')}} <br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
      </span>
      </div>
    </div>
  <vertifyDialog
    v-on:confirm='confirm'
    v-on:handleClose='handleClose'
    :confirmText='confirmText'
    :title='title'
    ref='verifyEmail'
  >
    <div v-show='isVertify' v-html="$t('t1222_please_check_your_account').replace('$1', '<span style=&quot;color: #043a97ff&quot;>'+userName+'</span>')">
<!--      <span>We have just sent a Vertification Code to your email address. </span>-->
<!--      <span style="color: #043a97ff">{{userName}}</span>-->
<!--      <span>Please check your email</span>-->
    </div>
    <div v-show='!isVertify'>
<!--      <span>Please enter the 6-digit code sent to </span>-->
<!--      <span style="color: #043a97ff">{{userName}}</span>-->
      <p v-html="$t('t1221_enter_verification_code').replace('$1', '<span style=&quot;color: #043a97ff&quot;>'+userName+'</span>')"></p>
      <div class='inputs' >
        <input v-for="(item, index) of verifyInputs" :key="index" type="text" v-model="verifyInputs[index]" @input='vertifyInput(index)'
         :class="{'input-code-error':errVeritifyCode, 'input-code':true}" pattern="[0-9]*">
      </div>
      <p v-if="errVeritifyCode" style="text-align: center;">{{$t('t1223_Invalid_Verification_Code')}}</p>
    </div >
  </vertifyDialog>
  </div>

</template>

<script>
  import auth from '../../auth/auth'
  import vertifyDialog from './vertifyDialog.vue'
  export default{
    components:{
      vertifyDialog
    },
    data(){
      return{
        password:'',new_password:'',new_password2:'',userType:'',isEn:false,isCz:false,
        isMg:false,isEs:false,isDe:false,isIt:false,isPo:false,isDu:false,isFr:false,isZh:false,isSw:false,
        //密码提示
        ps1:false, ps2:false, ps3:false, ps4:false, ps5:false, ps6:false,disF:true,isT:false,
        isEU:true,
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
        MFA: sessionStorage.getItem('MFA') === 'Y',
        confirmText:this.$t('send'),
        title:this.$t('t1222_Verify_your_account'),
        isVertify:true,isSendEmail:false,
        verifyInputs:new Array(6),verCode:'', errVeritifyCode:false, userName:sessionStorage.getItem('username')
      }
    },
    computed:{
      updateLocCode(){
        console.log('compute updateLocCode:');
        return this.$store.state.loc_code;
      },
    },
    watch:{
      updateLocCode(val){
        // this.$i18n.locale = val;
        console.log('watch updateLocCode:', val);
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }
    },
    methods:{
      vertifyInput(index){
        if(this.verifyInputs[index].length){
          let char = this.verifyInputs[index][this.verifyInputs[index].length - 1]
          if(char.match(/^[0-9]$/g)){
            this.verifyInputs[index] = char
            let tmpIndex = index
            if(index < 5){
              tmpIndex += 1
              document.getElementsByClassName('input-code')[tmpIndex].focus()
            }
          }else{
            this.verifyInputs[index] = ''
            document.getElementsByClassName('input-code')[index].focus()
          }
        }
      },
      changeMFA(flag){
        // 状态改变才会弹窗
        if(this.MFA !== flag){
          // 从开到关不需要验证邮箱
          if(flag){
            if(!this.isSendEmail){
              this.isVertify = true
              // this.confirmText = 'Vertify email'
              this.confirmText = this.$t('send')
            }
            this.$refs.verifyEmail.dialogVisible = true
          }else{
            this.sendChangeMFA()
          }
        }

      },
      sendChangeMFA(){
        // 此时MFA还没有改变状态
        const info = {
          'mfa': this.MFA?'N':'Y'
        }
        this.$http.post('/api/v2.1/account/mfa/setting',info).then(res=>{
          if(res.data.error === 0){
            sessionStorage.setItem('MFA', info.mfa)
            let tip = this.$t('saveTip');
            this.$message({
              type: 'success',
              message:tip
            });
            this.$refs.verifyEmail.dialogVisible = false
            this.isSendEmail = false
            this.MFA = !this.MFA
          }
        })
      },
      confirm(){
        if(this.isVertify){
          const postData = {
            user_name: this.userName,
            flag: this.userName.match(/^[\d]+$/g)?'mobile':'email',
            country: sessionStorage.getItem('country'),
            purpose:'login_mfa'
          }
          this.$http.post('/api/v2.0/seccode/send', postData).then(res=>{
            if(res.body.error === 0){
              this.isVertify = false
              this.confirmText = this.$t('confirm')
              this.isSendEmail = true
            }else if(res.body.error===1){
              let tip =this.$t('userNotExist');
              this.$message.error(tip);
            }else{
              let tip =this.$t('tryAgain');
              this.$message.error(tip);
            }
          })
        }else{
          let postData = {
            expire:5
          }
          postData[`${this.userName.match(/^[\d]+$/g)?'mobile':'email'}`] = this.userName
          postData.seccode = this.verifyInputs.join('')
          if(postData.seccode.length === 6){
            this.$http.post('/api/v2.1/seccode/check', postData).then(res => {
              if(res.body.error === 0){
                this.sendChangeMFA()
              }else{
                this.errVeritifyCode = true
              }
            })
          }
        }
      },
      handleClose(){
        this.$refs.verifyEmail.dialogVisible = false
      },
      back(){
        this.usterType = sessionStorage.getItem('userType');
        if(this.usterType==='D'){
          this.$router.push('/PatientList');
        }else if(this.usterType==='M'){
          this.$router.push('/carerConnection');
        }else{
          this.$router.push('/monitor');
        }
      },
      forgot(){
        sessionStorage.removeItem('A');
        sessionStorage.removeItem('B');
        sessionStorage.removeItem('C');
        sessionStorage.removeItem('D');
        this.$router.push('/updatePassword');
        if(sessionStorage.getItem('userType')==='D'){
          sessionStorage.setItem('udHcp',0);
        }else{
          sessionStorage.setItem('udHcp',1);
        }
      },
      apply(){
        let info = {
            password:this.password ,
            new_password:this.new_password
        };
        if(this.password){
          if(this.disF===true){
            if( this.new_password===this.new_password2){
              auth.modifyPassword(this,info);
            }
            else{
              let tip =this.$t('EntTheSame');
              this.$message.error(tip);
            }
          }
        }else{
          let tip =this.$t('EnterOld');
          this.$message.error(tip);
        }

      },
      //密码验证
      checkPassword(){
        let password = this.new_password.trim();
        if(password.length>5 && password.length<21){ this.ps2 =true; }else{ this.ps2 =false; }
        if(password.length>0) {
          if(password.indexOf(' ')===-1){ this.ps6 =true; }else{ this.ps6 =false; }
          if(password===this.full_name){ this.ps3 =false; }else{ this.ps3 =true; }
          let p1=/[a-z]/.test(password),p2=/[A-Z]/.test(password),p3=/[0-9]/.test(password),p4=/[!@#$%^&*()_+={},.;'\\":~`\[\]<>|/?]/.test(password),count=0;
          if(p1){count++;}
          if(p2){count++;}
          if(p3){count++;}
          if(p4){count++;}
          if(count>2){
            this.ps1 =true;
          }else{ this.ps1 =false; }

          for(let i =0;i<password.length-2;i++){
            if(password[i+1]-password[i]===1&&password[i+2]-password[i+1]===1){
              this.flag = 1;break;
            }else{
              this.flag = 0;
            }
            if(password[i]-password[i+1]===1&&password[i+1]-password[i+2]===1){
              this.flag = 1;break;
            }else{
              this.flag = 0;
            }
          }
          if(this.flag===0){ this.ps4 =true; }else{ this.ps4 =false; }

          for(let i =0;i<password.length-2;i++){
            if(password[i+1].charCodeAt()-password[i].charCodeAt()===1 && password[i+2].charCodeAt()-password[i+1].charCodeAt()===1){
              this.flag1 = 1;break;
            }else{
              this.flag1 = 0;
            }
            if(password[i].charCodeAt()-password[i+1].charCodeAt()===1 && password[i+1].charCodeAt()-password[i+2].charCodeAt()===1){
              this.flag1 = 1;break;
            }else{
              this.flag1 = 0;
            }
          }
          if(this.flag1===0){ this.ps5 =true; }else{ this.ps5 =false; }
        }
        if(this.ps1===true && this.ps2===true && this.ps3===true && this.ps4===true && this.ps5===true && this.ps6===true){
          this.isT = false;
          this.disF = true;
        }else{
          this.isT = true;
          this.disF = false;
        }
      },
    },
    mounted(){
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isZh = (sessionStorage.getItem('language')==='zh')?true:false;
      let countryIndex=localStorage.getItem('index');
      //console.info('countryIndex:'+countryIndex);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    }
  }
</script>
<style scoped>
  .newPatient-container{
    min-height:889px;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:62%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  @media screen and (max-width: 1500px){
    .container{
      width:92%;
    }
  }
  @media screen and (min-height: 950px){
    .container{
      min-height:900px;
    }
  }
  .main-container{
    width:97%;
    margin:0 auto;
    height: 839px;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:70px;
    height:20px;
    line-height: 20px;
    margin-right: 1%;
  }
  .de22{
    width:90px;
  }
  .cz22{
    width:80px;
  }
  .main-header-right img{
    display: block;
    margin-top: 5px;
    float: left;
  }
  .main-header-right p{
    float:right;
    color:#0082d2;
    margin-top: 2px;
    cursor: pointer;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto 15px;
    border:none;
  }

  .content{
    width: 98%;
    margin:0 auto 20px;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
  }
  .content input{
    margin-left: 30px;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:298px;
    height:35px;
    padding-left: 10px;
  }
  .content .vuerify-invalid{
    border: 1px solid #ff5252;
    height:35px;
    width:296px;
  }
  .content1{
   padding-left: 48px;
  }
  .content2{
    padding-left: 36px;
  }
  .zh1{
    padding-left: 44px;
  }
  .es1 span{
    margin-right: 55px;
  }
  .es2 span{
    margin-right: 77px;
  }
  .de1 span{
    margin-right: 42px;
  }
  .du1 span{
    margin-right: 29px;
  }
  .du2 span{
    margin-right: 22px;
  }
  .fr1 span{
    margin-right: 9px;
  }
  .fr2 span{
    margin-right: 22px;
  }
  .sw2 span{
    margin-right: 48px;
  }
  .sw3 span{
    margin-right: 18px;
  }
  .cz1 span{
    margin-right: 18px;
  }
  .cz2 span{
    margin-right: 24px;
  }
  .zh2{
    padding-left: 30px;
  }
  .it1 span{
    margin-right: 23px;
  }
  .it2 span{
    margin-right: 6px;
  }
  .po1 span{
    margin-right: 18px;
  }
  .po2 span{
    margin-right: 15px;
  }
  .forgot{
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#0082d2;
    letter-spacing:-0.44px;
   float: right;
    margin-right: 2%;
    margin-bottom: 15px;
    margin-top: -10px;
    cursor: pointer;
  }

  .tooltip p{
    background: url('../../assets/no.png') left center no-repeat;
    padding-left: 22px;
    margin-bottom: 2px;
    font-family:SFUIText-Regular;
    font-size:15px;
    letter-spacing:-0.37px;
    text-align: left;
    color:#3b3b3b;
  }
  .tooltip .longP{
    background: url('../../assets/no.png') left 1px no-repeat;
  }
  .tooltip .correct{
    background: url('../../assets/yes.png') left center no-repeat;
  }
  .tooltip .correct1{
    background: url('../../assets/yes.png') left 1px no-repeat;
  }

  .operate{
    width: 70%;
    float: right;
    margin-top:50px;
    margin-bottom: 20px;
    margin-right: 10px;
  }
  .operate button{
    background: transparent;
    border:1px solid #a3a3a3;
    border-radius:100px;
    width:150px;
    height:30px;
    outline: none;
    cursor: pointer;
    float: right;
  }
  .operate .create{
    margin-right: 20px;
  }
  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }
  .MFA-option{
    float: left;
    margin-right: 3%;

  }
  .MFA-left,.MFA-right{
    width: 80px;
    float: left;
    height: 25px;
    line-height: 25px;
    cursor: pointer;
    color: #0090ff;
    border: 1px solid #0090ff;
    text-align: center;

  }
  .MFA-left{
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }
  .MFA-right{
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }
  .MFA-choose{
    background-color:  #0090ff;
  }
  .MFA-choose p{
    color:#fff;
  }
  .inputs {
    display: flex;
    flex-direction: row;
    padding: 20px 0;
    justify-content: center;
  }
  .input-code {
    display: flex;
    width: 35px;
    height: 35px;
    flex: 0 0 35px;
    border: 2px solid #f2f4f8;
    border-radius: 6px;
    text-align: center;
    color: #8fa7d0;
  }
  .input-code + .input-code {
    margin-left: 15px;
  }
  .input-code:hover {
    border-color: #8fa7d0;
  }
  .input-code:focus {
    outline:none;
    border-color: #8fa7d0;
  }
  .input-code-error {
    border-color: #ff8484;
  }
  .input-code-error:hover {
    border-color: #ff8484;
  }
  .input-code-error:focus {
    outline:none;
    border-color: #ff8484;
  }
</style>



// WEBPACK FOOTER //
// changePassword.vue?5a59a1a2